<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import ArrowPath from '../icons/ArrowPath.svelte';

  export let results;

  function calculateResult(res) {
    if (!res) return -1;
    const checkedAllRequired = res[0] && res[3] && res[8];
    if (!checkedAllRequired) {
      return 0;
    }
    const checkedCount = res.map((v) => (v ? 1 : 0)).reduce((acc, v) => acc + v, 0);
    if (checkedCount < 5) {
      return 1;
    } else if (checkedCount < 8) {
      return 2;
    } else {
      return 3;
    }
  }

  $: result = calculateResult(results);

  let isComputing = true;
  onMount(() => {
    let timer = setTimeout(() => {
      isComputing = false;
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  });

  const dispatch = createEventDispatcher();
  function restart() {
    dispatch('restart', {});
  }
</script>

<section class="flex items-center justify-center flex-col text-center">
  {#if isComputing}
    <div class="flex items-center justify-center flex-col gap-8">
      <ArrowPath />
      <p>Auswertung läuft...</p>
    </div>
  {:else}
    {#if result === 0}
      <p class="text-xl">Die Diagnose CPPS ist <strong>unwahrscheinlich</strong>.</p>
    {:else if result === 1}
      <p class="text-xl">Die Diagnose CPPS ist <strong>möglich</strong>.</p>
    {:else if result === 2}
      <p class="text-xl">Die Diagnose CPPS ist <strong>relativ wahrscheinlich</strong>.</p>
    {:else if result === 3}
      <p class="text-xl">Die Diagnose CPPS ist <strong>sehr wahrscheinlich</strong>.</p>
    {/if}
    {#if result > 0}
      <p>
        Es kann sich für Sie lohnen, einen Spezialisten für die Behandlung des CPPS aufzusuchen.
      </p>
    {/if}
    <footer class="flex justify-center items-center gap-4 mt-8">
      <button class="btn-tertiary" on:click={restart}>Test neu starten</button>
    </footer>
  {/if}
</section>
